(function(){
  'use strict';
  /* V97 emergency guard: product pages must never accumulate duplicate observers
     or duplicate sticky handlers when Shopify sections are reloaded. */
  function guard(){
    document.querySelectorAll('.lbx-product-pro').forEach(function(root){
      if(root.dataset.lbx97Guard==='1')return;
      root.dataset.lbx97Guard='1';
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',guard,{once:true});else guard();
  document.addEventListener('shopify:section:load',guard);
})();
